
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Contract } from 'app/models/contract.model';
import { ContractService } from 'app/services/contract.service';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import { BaseFormComponent } from "../../base-form.component";
import { ContractListComponent } from '../contract-list/contract-list.component';

@Component({
    selector: 'app-contract-form',
    templateUrl: './contract-form.component.html',
    styleUrls: ['./contract-form.component.scss']
})
export class ContractFormComponent extends BaseFormComponent implements OnInit {
    public fileData: File[] = []
    private _contract: Contract = {
        status: true
    }
    private _contractList: Array<Contract>;
    public get contractList() {
        return this._contractList;
    }

    public get model() {
        return this._contract
    }
    public set model(v: Contract) {
        this._contract = v;
    }

    constructor(
        private toasterService: ToasterService,
        private _translateService:TranslateService,
        private _contractService: ContractService,
        public dialogRef: MatDialogRef<ContractListComponent>,
        @Inject(MAT_DIALOG_DATA) public data
    ) {
        super();
    }

    public async ngOnInit() {
        try {
            this._contractList = await this._contractService.getContracts(this.data.id);

        } catch (error) {
            console.warn(error);

        }
    }
    public fileChange(f) {
        this.fileData.push(f[0])
    }

    async save() {
        if (this.form.invalid) {
            this.toasterService.toastWarning(this._translateService.instant("PLEASE_FILL_IN_THE_FORM_CORRECTLY"))
            return
        }
        if (this.fileData.length == 0) {
            this.toasterService.toastWarning(this._translateService.instant("FILE_NOT_SELECTED"))
            return;
        }
        var statusControl = this.contractList.filter(e => e.status == true);
        if (statusControl.length > 0 && this.model.status == true) {
            this.toasterService.toastWarning(this._translateService.instant("THERE_IS_ALREADY_AN_ACTIVE_CONTRACT"))
            return;
        }
        this.model.companyId = this.data.id;
        const formData = new FormData();

        try {
            formData.append("files", this.fileData[0])
            let uresponse = await this._contractService.upload(formData)
            this.model.fileName = uresponse.toString();
            if (uresponse[0] != null) {
                await this._contractService.add(this.model);
                this.added.emit(true);
            }
            else {
                this.toasterService.toastFail(this._translateService.instant("FILE_COULD_NOT_BE_UPLOADED"))
            }
        } catch (error) {
            console.warn(error);
            this.added.emit(false);
        }

    }

}
